import { defineComponent as m, resolveDirective as t, createElementBlock as a, openBlock as s, renderSlot as i, withDirectives as r, createElementVNode as v, normalizeClass as p, vShow as u } from "vue";
import { _ as f } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const b = { class: "tess__load-more" }, g = { class: "tess--loading__wrapper" }, h = /* @__PURE__ */ m({
  __name: "LoadMoreWrapper",
  props: {
    isEnable: {
      type: Boolean,
      default: !1
    },
    loaderClass: {
      type: String,
      default: ""
    }
  },
  emits: ["load-more"],
  setup(e, { emit: l }) {
    const d = l, n = () => {
      d("load-more");
    };
    return (o, C) => {
      const c = t("t-visible"), _ = t("t-loading");
      return s(), a("div", b, [
        i(o.$slots, "default", {}, void 0, !0),
        r(v("div", g, [
          r((s(), a("div", {
            class: p([[e.loaderClass], "tess--loading__virtual"])
          }, [
            i(o.$slots, "loading-animation", {}, void 0, !0)
          ], 2)), [
            [c, { timer: 300, visibleFn: n }],
            [_, !0]
          ])
        ], 512), [
          [u, e.isEnable]
        ])
      ]);
    };
  }
}), w = /* @__PURE__ */ f(h, [["__scopeId", "data-v-24899a9c"]]);
export {
  w as default
};
